// @ts-check
import { Browser } from '../utils/browsercheck';
import { onDomReady } from '../utils/dom';
import * as ScrollUtil from '../utils/scrolling';

function deleteEmptyPTags() {
    // Lösche leere p Tags mit Leerzeichen
    document.querySelectorAll('#main p').forEach((p) => {
        if (p.innerHTML.replace(/\s| |&nbsp;/g, '') === '') {
            p.remove();
        }
    });
}

function contrastMode() {
    let setting = document.documentElement.getAttribute('data-contrast');
    const buttons = document.querySelectorAll('button.change-contrast');
    const label = (mode) => (mode === 'more' ? 'Deaktiviere den hohen Kontrast' : 'Aktiviere den hohen Kontrast');

    buttons.forEach((button) => {
        button.setAttribute('aria-label', label(setting));

        button.addEventListener('click', () => {
            setting = setting === 'more' ? 'no-preference' : 'more';
            document.documentElement.setAttribute('data-contrast', setting);
            localStorage.setItem('contrast', setting);
            button.setAttribute('aria-label', label(setting));
        });
    });
}

/**
 * @param {string} not :not-Selector für Elemente, die kein Icon bekommen sollen
 */
function addExternalLinkClass(not = '') {
    const hostReg = new RegExp(location.hostname, 'i');

    document.querySelectorAll(`#main a[href^="http://"]${not}, #main a[href^="https://"]${not}`).forEach((a) => {
        if (!hostReg.test(a.href) && !a.parentElement.classList.contains('image_container')) {
            a.classList.add('external-link');
        }
    });
}

function setCustomProperties() {
    document.body.style.setProperty('--scrollbar-width', Browser.scrollbarWidth() + 'px');
}

function addLoadingClassToImages() {
    /** @type {NodeListOf<HTMLImageElement>} */
    const images = document.querySelectorAll('img:not([href$=".svg"]');

    if (!images.length) {
        return;
    }

    images.forEach((img) => {
        if (img.complete && img.naturalHeight !== 0) {
            return;
        }

        if (img.hasAttribute('width')) {
            img.style.setProperty('--loading-width', img.getAttribute('width') + 'px');
        }

        img.classList.add('loading');
        img.onload = () => img.classList.remove('loading');
    });
}

function setTouchDeviceClass() {
    if (Browser.isTouchDevice()) {
        document.documentElement.classList.add('touch');
    } else {
        document.documentElement.classList.remove('touch');
    }
}

function scrollToAnchor() {
    document.querySelectorAll('a[href*="#"]').forEach((a) => {
        a.addEventListener('click', function (e) {
            ScrollUtil.scrollToAnchor(e, this);
        });
    });
}

function scrollToContent() {
    const button = document.querySelector('.module-content-link button');
    const target = document.querySelector('#container');

    button?.addEventListener('click', () => {
        ScrollUtil.scrollToTarget(target);
    });
}

/**
 * Seite einblenden wenn sie fertig geladen ist
 */
function fadeInSite() {
    const loader = document.getElementById('page-loader');

    loader?.classList.add('hide');
    setTimeout(() => document.body.classList.replace('loading', 'loaded'), 400);
}

function polyfillHasSelector() {
    if (window.CSS.supports('selector(:has(*))')) {
        return;
    }

    document.querySelectorAll('td[colspan]').forEach((td) => {
        const tr = td.parentElement;
        tr?.classList.add('has-colspan');
        tr?.previousElementSibling?.classList.add('before-colspan');
    });

    const banner = document.querySelector('.mod_article.banner');

    if (banner) {
        document.getElementById('wrapper')?.classList.add('has-banner');
    }
}

(function () {
    document.body.classList.add('loading');
    setTouchDeviceClass();
    setCustomProperties();
})();

onDomReady(() => {
    addExternalLinkClass();
    addLoadingClassToImages();
    contrastMode();
    fadeInSite();

    deleteEmptyPTags();
    polyfillHasSelector();
    scrollToAnchor();
    scrollToContent();
});

window.addEventListener('load', () => {
    ScrollUtil.scrollToAnchor(null, window.location);
});

window.addEventListener('resize', () => {
    setCustomProperties();
    setTouchDeviceClass();
});
